var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a3 3 0 0 1 3-3h19.773a3 3 0 0 1 3 3v21a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm22.09 2.523a1.84 1.84 0 1 1-3.681 0 1.84 1.84 0 0 1 3.682 0ZM9 8.48a6.316 6.316 0 0 1 3.58-1.117c1.71 0 3.348.699 4.556 1.942a6.725 6.725 0 0 1 1.887 4.686c0 1.31-.377 2.592-1.085 3.682a6.486 6.486 0 0 1-2.892 2.44 6.277 6.277 0 0 1-3.723.378 6.39 6.39 0 0 1-3.299-1.814 6.688 6.688 0 0 1-1.763-3.393 6.803 6.803 0 0 1 .367-3.83A6.59 6.59 0 0 1 9 8.48Zm1.194 9.184a4.211 4.211 0 0 0 2.386.745c1.14 0 2.232-.466 3.038-1.294a4.483 4.483 0 0 0 1.258-3.124c0-.874-.252-1.728-.724-2.455a4.324 4.324 0 0 0-1.928-1.627 4.185 4.185 0 0 0-2.482-.252 4.26 4.26 0 0 0-2.2 1.21 4.459 4.459 0 0 0-1.175 2.262 4.536 4.536 0 0 0 .245 2.553 4.394 4.394 0 0 0 1.582 1.982Z",
    fill: "#DDD"
  })));
};

export default SvgInstagram;